import auth from '@/services/CRMinitAuth';

const list = query => {
  return auth.get(`${process.env.VUE_APP_CRM_API}exams_task_list/`, {
    params: query
  });
};

const patch = (examID, data) => {
  return auth.patch(`${process.env.VUE_APP_CRM_API}exams_task_list/${examID}/`, data);
};


const addLog = (id, comment) => {
  return auth.post(`${process.env.VUE_APP_CRM_API}exams_task_list/${id}/add_log/`, comment);
};


export default {
  list,
  patch,
  addLog
};
